import { initTracing } from '@box/observability';
import Cookies from 'js-cookie';

import type { WindowBoxConfig } from '../../types/window';

const ALLOWED_ENVIRONMENTS = ['dev', 'staging', 'prod', 'sanity'];
const ALLOWED_COOKIES = ['1', 'on', 'true', true];

function getConfig(): WindowBoxConfig {
  return window.Box.config;
}

// Loosely based on EUA logic. Falsy values like undefined or ''
// default to 'dev', while set values not in ALLOWED_ENVIRONMENTS will return 'unknown'
function getRumEnvironment() {
  const { environment } = getConfig().runtimeMetadata;
  if (!environment) return 'dev';

  return ALLOWED_ENVIRONMENTS.includes(environment) ? environment : 'unknown';
}

export const loadTracing = () => {
  const {
    version,
    rumRatio: sampleRatio,
    rumBeaconUrl: beaconEndpoint,
  } = getConfig();

  const deploymentEnvironment = getRumEnvironment();
  const debugCookie = Cookies.get('rumDebug') || false;

  try {
    initTracing({
      applicationName: 'Forms',
      beaconEndpoint,
      debug: ALLOWED_COOKIES.includes(debugCookie),
      deploymentEnvironment,
      ignoreUrls: [
        /^blob/i, // Blob URLs can be large and are low value
        /^data/i, // Data URLs can be large and slow down regex checks
        /localhost/i, // Local calls are not relevant and mainly used by Box Edit
        /127\.0\.0\.1/i, // Local calls are not relevant and mainly used by Box Edit
      ],
      sampleRatio: parseFloat(sampleRatio) || 0,
      version,
    });
  } catch (error) {
    if (deploymentEnvironment !== 'prod') {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  }
};
